<template>
  <div class="static-liul">
    <div class="input-content">
      <ElementSelect
        label="时间粒度"
        :options="timeSelectsOptions"
        @selectValue="(e) => (dateLidu = e)"
      />

      <ElementSelect
        label="时间范围"
        innerStyle="margin-left: 24px;"
        :options="timeRangeSelectsOptions"
        @selectValue="(e) => (dateRange = e)"
      />

      <div class="query-btn" @click="searchClick">查询</div>
    </div>
    <div class="echart-liul">
      <EchartLine :dataAxis="dataAxis" :ydata="ydata" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import EchartLine from "@/components/EchartLine.vue";
import { childStatic } from "@/service/requestRes";
export default {
  props: {
    mytype: String,
    current_host: String,
  },
  components: {
    EchartLine,
  },
  data() {
    return {
      dataAxis: [],
      ydata: {}, 
      dateLidu: "",
      dateRange: "",
    };
  },
  computed: {
    timeSelectsOptions() {
      return [
        {
          label: "1分钟",
          value: "1m",
        },
        {
          label: "5分钟",
          value: "5m",
        },
        {
          label: "1小时",
          value: "1h",
        },
        {
          label: "1天",
          value: "1d",
        },
      ];
    },
    timeRangeSelectsOptions() {
      return [
        {
          label: "30分钟",
          value: "30m",
        },
        {
          label: "6小时",
          value: "6h",
        },
        {
          label: "12小时",
          value: "12h",
        },
        {
          label: "24小时",
          value: "24h",
        },
        {
          label: "最近7天",
          value: "7d",
        },
        {
          label: "最近30天",
          value: "30d",
        },
      ];
    },
  },
  mounted() {},
  methods: {
    searchClick() {
      if (!this.dateLidu) {
        this.$message({
          message: "请选择时间粒度",
          type: "error",
        });
        return;
      }
      if (!this.dateRange) {
        this.$message({
          message: "请选择时间范围",
          type: "error",
        });

        return;
      }
      this.getStaticData({
        host: this.current_host,
        func: this.mytype,
        interval_time: this.dateLidu,
        interval_day: this.dateRange,
      });
    },
    getStaticData({ func, host, interval_time, interval_day }) {
      childStatic({ func, host, interval_time, interval_day }).then((res) => {
        const { data, code, msg } = res || {};
        const newArr = [];
        const newX = [];
        if (code === 1) {
            data && (typeof data === Array) && data.forEach(item => {
                const { time, wafs, hits, flows } = item || {};
                if (this.mytype === 'hits') {
                    newX.push(hits);
                } else if (this.mytype === 'flows') {
                    newX.push(flows);
                } else if (this.mytype === 'wafs') {
                    newX.push(wafs);
                }
                newArr.push(time);
            });
            this.ydata = newArr;
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.static-liul {
  min-height: 500px;
  .echart-liul {
    height: 300px;
  }
  .input-content {
    display: flex;
    align-items: flex-end;
    margin-bottom: 15px;
  }
  .query-btn {
    z-index: 999;
    width: 100px;
    height: 44px;
    background: #336dff;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Semibold;
    font-size: 14px;
    color: #ffffff;
    margin: 0 auto;
    cursor: pointer;
    margin-left: 30px;
    margin-bottom: 10px;
  }
}
</style>
